<template>
    <div
        class="collapse"
        :class="{
            'collapse--is-active': isActive,
            'collapse--is-animating': isAnimating,
        }"
        :style="style"
        @transitionend="onTransitionEnd"
    >
        <slot></slot>
    </div>
</template>

<script>
import { EVENT_ACCORDION, EVENT_RECEIPT, EVENT_TOGGLE } from '../constants/events';

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        value: {
            type: Boolean,
            default: false,
        },
        accordion: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isActive: this.value,
            isAnimating: false,
            height: null,
        };
    },
    computed: {
        style() {
            return {
                height: this.height != null ? `${this.height}px` : null,
            };
        },
    },
    watch: {
        value(v) {
            this.setValue(v);
        },
    },
    mounted() {
        this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);
        this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
    },
    methods: {
        setValue(value) {
            if (value) {
                this.doShow();
            } else {
                this.doHide();
            }
            this.emitState(value);
        },
        doShow() {
            this.isActive = true;
            this.startAnimation(this.isActive);
        },
        doHide() {
            this.isActive = false;
            this.startAnimation(this.isActive);
        },
        startAnimation(toActive) {
            this.isAnimating = true;
            this.height = this.$el.offsetHeight;

            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.height = toActive ? this.$el.scrollHeight : 0;
                    });
                });
            });
        },
        handleToggleEvt(target) {
            if (target !== this.id) {
                return;
            }
            this.toggle();
        },
        handleAccordionEvt(openedId, accordion) {
            if (!this.accordion || accordion !== this.accordion) {
                return;
            }
            if (openedId === this.id) {
                if (!this.isActive) {
                    this.toggle();
                }
            } else if (this.isActive) {
                this.toggle();
            }
        },
        listenOnRoot(event, callback) {
            this.$root.$on(event, callback);
            this.$on('hook:beforeDestroy', () => {
                this.$root.$off(event, callback);
            });
            return this;
        },
        emitState(value) {
            this.$emit('input', value);
            this.$root.$emit(EVENT_RECEIPT, this.id, value);

            if (this.accordion && value) {
                this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
            }
        },
        toggle() {
            this.setValue(!this.isActive);
        },
        onTransitionEnd() {
            this.height = null;
            this.isAnimating = false;
        },
    },
};
</script>

<style lang="less">
.collapse {
    display: flow-root;
    height: 0;
    overflow: hidden;
    transition: height .3s ease-in-out;
}

.collapse--is-active {
    height: auto;
    overflow: visible;
}

.collapse--is-animating {
    height: auto;
    overflow: hidden;

    &.collapse--is-active {
        height: 0;
    }
}
</style>
